import * as React from "react";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { OrderStatusPanel } from "../OrderStatusPanel";
import { useOrderBook } from "@/hooks/queries/useOrderBook";
import type { OrderRow } from "../OrderTable";

interface ExecutionOrderPayload {
  execution_id: string;
  instrument_token: string;
  side: string;
  quantity: number;
  status: string;
}

export function OrderStatusSection(): React.JSX.Element {
  const orderBookQuery = useOrderBook();

  return (
    <QueryStateBoundary query={orderBookQuery}>
      {(payload) => {
        const rows: OrderRow[] = (payload as unknown as ExecutionOrderPayload[]).map((o) => ({
          execution_id: o.execution_id,
          instrument_token: o.instrument_token,
          side: o.side,
          quantity: o.quantity,
          status: o.status,
        }));
        return <OrderStatusPanel orders={rows} />;
      }}
    </QueryStateBoundary>
  );
}
